import Slider from '@/components/slider'
import { e2eCompensationsSlidesConfig } from './config/e2eCompensations'
import { mapState, mapActions } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION
} from '@/store/types'
import maNavbarCategory from '@/components/navbarCategories'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_STATES } from '@/modules/Flow/constants'

export default {
  name: 'claimCompensationType',

  mixins: [flowMixin],

  components: {
    Slider,
    maNavbarCategory
  },

  data: function () {
    return {
      compensationSlides: e2eCompensationsSlidesConfig()
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyResultDeclaration: 'resultDeclaration'
    })
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    handleLinkClick(stateTransition) {
      this.goToNextState(stateTransition)
    },

    async updateGagSliderAmount() {
      const gagSlide = this.compensationSlides.filter(
        (slide) => slide.name === FLOW_STATES.GAG_DETAILS
      )[0]
      gagSlide.amount = this.stateWarrantyResultDeclaration
    },
    handleClickPrevRoute() {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },
    getSliderOptions: function () {
      return (
        this.compensationSlides.filter((t) => {
          return this.getFlowTransitions.includes(t.transition)
        }) || []
      )
    }
  },
  mounted() {
    const sinisterId = this.getSinisterId
    this.actGetResultDeclaration(sinisterId)
    this.compensationSlides = this.getSliderOptions()
    this.updateGagSliderAmount()
  },

  watch: {
    stateWarrantyResultDeclaration() {
      this.updateGagSliderAmount()
    }
  }
}
